import { getStore } from "@core/store";
export var LicenseStore = getStore();

//# sourceMappingURL=LicenseStore.js.map